import { forwardRef } from 'react';

import { useI18n } from '#hooks/useI18n';

import { Flex } from '@zazume/zzm-base';

import { Input } from '#/components/forms/input/InputBase';

import { IbanVoPValidation } from './IbanVoPValidation';

/** @deprecated Use IbanFieldWithVoP (ZZMForm) instead */
interface IbanFieldWithVoPLegacyProps {
  name: string;
  legalName?: string;
  ibanValue?: string;
  label?: string;
  placeholder?: string;
  defaultValue?: string;
  error?: any;
  isOptional?: boolean;
}

/** @deprecated Use IbanFieldWithVoP (ZZMForm) instead */
export const IbanFieldWithVoPLegacy = forwardRef<HTMLInputElement, IbanFieldWithVoPLegacyProps>(
  ({ name, legalName, ibanValue, label, placeholder, defaultValue, error, isOptional }, ref) => {
    const { t } = useI18n();

    return (
      <Flex direction="column" gap="s4">
        <Input
          name={name}
          ref={ref}
          label={label || t('general.iban')}
          type="text"
          placeholder={placeholder}
          defaultValue={defaultValue}
          error={error}
          isOptional={isOptional}
        />
        <IbanVoPValidation iban={ibanValue} name={legalName} />
      </Flex>
    );
  }
);
